<template>
  <app-view-layout
    class="notifications-page"
    header="Powiadomienia"
    :subheader="newNotificationsSuffix"
  >
    <template #toolbarMenu>
      <v-select
        v-model="filter"
        :items="statusOptions"
        item-text="label"
        item-value="value"
        v-bind="props.select"
        class="width-160"
        @change="filterNotifications"
      />
    </template>

    <template #content>
      <v-card class="mt-4 pa-8">
        <v-card-title class="pa-0 mb-4">
          Lista Powiadomień
          <button
            class="notifications-page__clear-button"
            @click="clearNotifications"
          >
            Oznacz wszystkie jako przeczytane
          </button>
        </v-card-title>

        <template v-if="notifications.length">
          <AppNotification
            v-for="notification in notifications"
            :key="notification.id"
            :notification="notification"
          />
        </template>

        <AppEmptyList
          v-else
          class="py-16"
          header="Brak powiadomień"
          text=""
        />
      </v-card>

      <AppPagination
        v-if="notifications.length"
        hide-page-options
        @change="fetchNotifications"
      />
    </template>
  </app-view-layout>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import utils from '@/helpers/utils';
import props from '@/helpers/componentsProps';
import AppViewLayout from '@/components/Layout/AppViewLayout.vue';
import AppNotification from '@/components/UI/AppNotification.vue';
import AppPagination from '@/components/UI/AppPagination.vue';
import AppEmptyList from '@/components/UI/AppEmptyList.vue';

export default {
  components: {
    AppViewLayout,
    AppNotification,
    AppPagination,
    AppEmptyList,
  },

  data() {
    return {
      props,
      statusOptions: [
        {
          label: 'Wszystkie',
          value: null,
        },
        {
          label: 'Nieprzeczytane',
          value: false,
        },
        {
          label: 'Przeczytane',
          value: true,
        },
      ],
      filter: null,
    };
  },

  computed: {
    ...mapState('notifications', [
      'notifications',
      'unreadNotificationsCount',
    ]),

    newNotificationsSuffix() {
      return utils.getCounterWithSuffix(this.unreadNotificationsCount,
      'nowe powiadomienie', 'nowe powiadomienia', 'nowych powiadomień');
    },
  },

  created() {
    this.setFilters({ seen: this.filter })
      .then(() => {
        this.fetchNotifications();
      });
  },

  methods: {
    ...mapActions('filters', [
      'setFilters',
    ]),

    ...mapActions('notifications', [
      'fetchNotifications',
      'changeAllNotificationsStatus',
    ]),

    ...mapActions('snackbar', [
      'showSnackbar',
    ]),

    clearNotifications() {
      if (this.unreadNotificationsCount) {
        this.changeAllNotificationsStatus();
      } else {
        this.showSnackbar({
          message: ['Nie masz nieprzeczytanych powiadomień'],
          type: 'error',
        });
      }
    },

    filterNotifications() {
      this.setFilters({ seen: this.filter })
        .then(() => {
          this.fetchNotifications();
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.notifications-page {
  &__clear-button {
    color: $primary;
    font-size: 12px;
    letter-spacing: 0;
  }
  &::v-deep .v-select__slot {
    font-weight: 500;
  }
}
</style>
